import { identityApiVersion } from "@istari-frontend/auth";

import { isIdentityServiceEnabled } from "~/utils/identity-service";

/** Which identity path the app is on: Zitadel directly, identity-service's v1 flow, or its v2 flow. */
export type IdentityMode = "zitadel-direct" | "identity-v1" | "identity-v2";

// The one place the app decides its identity mode; consumers read the session, not the flags.
export function identityMode(): IdentityMode {
  if (!isIdentityServiceEnabled()) return "zitadel-direct";
  return identityApiVersion() === "v2" ? "identity-v2" : "identity-v1";
}

export { isIdentityServiceEnabled };
